class ExtendFAQSearchPageApi {
  constructor() {
    this.allData = false;
    this.resultData = [];
  }
  async init() {
    try {
      this.allData = await this.getAllData();
      this.removeLoading();
      if (this.allData.length === 0) {
        console.warn("未获取到FAQ页面数据");
        return;
      }
      const params = new URLSearchParams(window.location.search);
      const keyword = params.get("keyword");
      this.initSearch({
        defaultQuery: keyword,
      });
    } catch (error) {
      console.warn(error);
    }
  }

  async getAllData() {
    let allPages = [];
    let cursor = null;
    let hasNextPage = true;

    while (hasNextPage) {
      const query = `{
                    pages(first: 250${cursor ? `, after: "${cursor}"` : ""}) {
                      pageInfo { hasNextPage endCursor }
                      edges {
                        node {
                          id
                          title
                          handle
                          onlineStoreUrl
                          createdAt
                          updatedAt
                          isFAQ:metafield(namespace: "custom", key: "is_faq") {
                            value
                          }
                          summary: metafield(namespace: "custom", key: "summary") {
                            value
                          }
                        }
                      }
                    }
                  }`;
      const res = await fetch("/api/2024-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "5bd81107951eb55ab2639a639b539d85",
        },
        body: JSON.stringify({ query }),
      });

      if (!res.ok) throw new Error(`网络请求失败: ${res.status}`);
      const data = await res.json();
      if (!data?.data?.pages) throw new Error("数据结构异常");
      const { edges, pageInfo } = data.data.pages;

      // 只保留 is_faq 为 true 的
      const faqPages = edges
        .filter((e) => e.node.isFAQ?.value === "true")
        .map((e) => ({
          id: e.node.id,
          title: e.node.title,
          handle: e.node.handle,
          url: e.node.onlineStoreUrl || `/pages/${e.node.handle}`, // 备用拼接
          isFAQ: true,
          summary: e.node.summary?.value || "",
          createdAt: new Date(e.node.createdAt).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
          updatedAt: new Date(e.node.updatedAt).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
        }));

      allPages = allPages.concat(faqPages);
      hasNextPage = pageInfo.hasNextPage;
      cursor = pageInfo.endCursor;
    }

    return allPages;
  }

  removeLoading() {
    let searchPage = document.getElementById("faq-search-page");
    let loadingEle = searchPage.querySelector(".efsp-loading");
    if (loadingEle) {
      loadingEle.remove();
    }
  }

  initSearch({ defaultQuery } = {}) {
    let that = this;
    let allData = that.allData;
    const searchPageInputWrapper = document.getElementById(
      "faq-search-page-input-wrapper"
    );
    const searchPageInput = document.getElementById("faq-search-page-input");
    const searchPageButton = document.getElementById("faq-search-page-button");
    const searchPageResults = document.getElementById(
      "faq-search-page-results"
    );
    if (!!defaultQuery) {
      searchPageInput.value = defaultQuery;
      _renderResults(defaultQuery);
    } else {
      _setMessage({
        title: "No keywords have been entered.",
        content: "Please enter the keywords in the input box above.",
      });
    }
    // 设置提示信息
    function _setMessage({ title, content } = {}) {
      const searchPageMessage = document.getElementById(
        "faq-search-page-message"
      );
      const messageTitle = searchPageMessage.querySelector(
        ".efsp-message-title"
      );
      const messageContent = searchPageMessage.querySelector(
        ".efsp-message-content"
      );
      messageTitle.innerHTML = title || "";
      messageContent.innerHTML = content || "";
    }
    // 获取搜索关键词
    function _getQuery() {
      return searchPageInput.value.trim().toLowerCase();
    }
    // 渲染搜索结果
    function _renderResults(query) {
      searchPageResults.innerHTML = "";

      if (query.length === 0) {
        return;
      }

      const matched = allData.filter(
        (page) =>
          page.title.toLowerCase().includes(query) ||
          (page.summary || "").toLowerCase().includes(query)
      );

      if (matched.length === 0) {
        _setMessage({
          title: "No relevant content was found.",
          content: "Please re-enter the keywords.",
        });
        return;
      } else {
        _setMessage({
          title: "Query successful",
          content: `A total of ${matched.length} relevant results were found.`,
        });
      }

      matched.forEach((page, index) => {
        const highlightedTitle = page.title.replace(
          new RegExp(`(${query})`, "gi"),
          "<b>$1</b>"
        );
        const highlightedSummary = (page.summary || "").replace(
          new RegExp(`(${query})`, "gi"),
          "<b>$1</b>"
        );
        const resultsItem = document.createElement("div");
        resultsItem.setAttribute("class", "efsp-results-item");
        resultsItem.innerHTML = `
                        <a href="${page.url}" class="efsp-results-item__title">${highlightedTitle}</a>
                        <p class="efsp-results-item__summary">${highlightedSummary}</p>
                        <p class="efsp-results-item__date">${page.updatedAt}</p>
                      `;
        searchPageResults.appendChild(resultsItem);
      });
    }
    searchPageButton.addEventListener("click", () => {
      let query = _getQuery();
      if (!!query) {
        _renderResults(query);
      }
    });
    searchPageInput.addEventListener("focus", () => {
      searchPageInputWrapper.classList.add("focus");
    });
    searchPageInput.addEventListener("blur", () => {
      searchPageInputWrapper.classList.remove("focus");
    });
  }
}
